const ERROR = {
  'test message': 'test',
  NO_PVP_LOBBY: 'The lobby is not exist!',
  LOBBY_OWNER_DISCONNECTED: 'The lobby owner is disconnected!',
  GAME_IS_JUDGING: 'Game is judging!',
  OPPONENT_DISCONNECTED: 'Opponent is disconnected!',
  UNFINISHED_GAME: 'The user still has an unfinished game!',
  SELF_CREATED_LOBBY: 'Can not enter self-created lobby!',
  INCORRECT_ACTION: 'Incorrect action!',
  LOBBY_NOT_STARTED: 'The lobby has not started yet',
  VERIFICATION_NOT_OVER: 'There are Verification not over',
};

export default ERROR;
